import MuiLink from '@mui/material/Link';

interface Props {
  readonly eMail?: string | null;
}

export const EmailAddress = ({ eMail }: Readonly<Props>) =>
  eMail ? (
    <MuiLink color="secondary" href={`mailto:${eMail}`}>
      {eMail}
    </MuiLink>
  ) : (
    <>Inconnue</>
  );
